import type { ReactNode } from 'react';
import {
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   WikiLink,
   CustomHeading,
   History,
   CustomBulletList,
   CustomOrderedList,
   CustomListItem,
   CustomHardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   Video,
   Table,
} from '../extensions';
import { MenuSeparator } from '../components/MenuSeparator';
import { TiptapMenubar } from '../components/TiptapMenubar';
import { TextStyleDropdown } from '../components/TextStyleDropdown';
import { VideoInsertDropdown } from '../components/VideoInsertDropdown';
import {
   BoldButton,
   ItalicButton,
   CodeButton,
   LinkButton,
   UndoButton,
   RedoButton,
   BulletListButton,
   OrderedListButton,
   IndentButton,
   UnindentButton,
} from '../components/buttons';
import type { TiptapExtension } from '.';

export const GuideIntroExtensions: Array<TiptapExtension> = [
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink.configure({ newLinksOpenInNewWindow: true }),
   WikiLink,
   CustomHeading,
   History,
   CustomBulletList,
   CustomOrderedList,
   CustomListItem,
   CustomHardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   Video,
   Table,
];

// Changing the controls here? Mirror them in GuideIntroMenuBarDisabled
// (guide_intro_disabled.tsx), the static twin shown in wikitext source mode.
export const GuideIntroMenuBar = ({ menubarEnd }: { menubarEnd?: ReactNode }) => (
   <TiptapMenubar menubarEnd={menubarEnd}>
      <BoldButton />
      <ItalicButton />
      <CodeButton />
      <LinkButton />
      <MenuSeparator />
      <TextStyleDropdown />
      <MenuSeparator />
      <BulletListButton />
      <OrderedListButton />
      <UnindentButton />
      <IndentButton />
      <MenuSeparator />
      <VideoInsertDropdown />
      <MenuSeparator />
      <UndoButton />
      <RedoButton />
   </TiptapMenubar>
);
